import {
  EntityKindPicker,
  EntityTypePicker,
  UserListPicker,
  EntityOwnerPicker,
  EntityLifecyclePicker,
  EntityTagPicker,
  EntityNamespacePicker,
  EntityProcessingStatusPicker,
  EntityOwnerPickerProps,
  UserListFilterKind,
} from '@backstage/plugin-catalog-react';
import { EntityCriticalityPicker } from '../EntityCriticalityFilter';

export interface CustomFiltersProps {
  initialKind?: string;
  initiallySelectedFilter?: UserListFilterKind;
  ownerPickerMode?: EntityOwnerPickerProps['mode'];
  initiallySelectedNamespaces?: string[];
}

export const CustomFilters = (props: CustomFiltersProps) => {
  const {
    initialKind,
    initiallySelectedFilter,
    ownerPickerMode,
    initiallySelectedNamespaces,
  } = props;

  return (
    <>
      <EntityKindPicker initialFilter={initialKind} />
      <EntityTypePicker />
      <UserListPicker initialFilter={initiallySelectedFilter} />
      <EntityOwnerPicker mode={ownerPickerMode} />
      <EntityLifecyclePicker />
      <EntityCriticalityPicker />
      <EntityTagPicker />
      <EntityProcessingStatusPicker />
      <EntityNamespacePicker
        initiallySelectedNamespaces={initiallySelectedNamespaces}
      />
    </>
  );
};
